import s from './CompanyStatsSection.scss'

const CompanyStatsSection = ({ stats }) => {
  return (
    <>
      <div className={s.info}>
        <h5>Client Awarded Rate</h5>
        <p>Out of all the jobs this Client bid, how many did they win?</p>
        <p className={s.noMargins}>
          Total # of jobs this Client is added to: {stats.totalNrOfJobsClientWasAdded}
        </p>
        <p className={s.noMargins}>
          Jobs in Lead, New, Estimating, Follow-up: {stats.totalNrOfOpenJobsClientWasAdded}
        </p>
        <p>Jobs in Closed, Won, Lost, Project: {stats.totalNrOfClosedJobsClientWasAdded}</p>
        <p className={s.noMargins}>
          Out of these how many were they awarded: {stats.totalNrOfJobsClientWasAddedAreAwarded}
        </p>
        <p className={s.noMargins}>
          Awarded in Lead, New, Estimating, Follow-up:{' '}
          {stats.totalNrOfOpenAwardedJobsClientWasAdded}
        </p>
        <p className={s.noMargins}>
          Awarded in Closed, Won, Lost, Project: {stats.totalNrOfClosedAwardedJobsClientWasAdded}
        </p>
        <p className={s.rate}>Overall Client Awarded Rate: {stats.clientAwardedRatePercent}%</p>
      </div>
      <div className={s.info}>
        <h5>Our Win Rate with Client</h5>
        <p>Out of all the jobs this Client won, how many did we win?</p>
        <p className={s.noMargins}>
          Total # of Jobs this Client was awarded: {stats.totalNrOfJobsClientWasAwarded}
        </p>
        <p className={s.noMargins}>
          Out of these how many did we win: {stats.totalNrOfJobsClientWasAwardedAndCompanyWon}
        </p>
        <p className={s.rate}>
          Our Win Rate with this Client: {stats.companyWinRateWithTheClientPercent}%
        </p>
      </div>
      <div className={s.info}>
        <h5>Bid Rate for this Client</h5>
        <p>Out of all the bids we sent to this Client, how many did we win?</p>
        <p className={s.noMargins}>
          Total Bids Sent Out to Client: {stats.totalBidsSentOutToClient}
        </p>
        <p className={s.noMargins}>
          Out of these how many did we win: {stats.totalBidsSentOutToClientCompanyWon}
        </p>
        <p className={s.rate}>Bid Rate: {stats.bidRatePercent}%</p>
      </div>
    </>
  )
}

export default CompanyStatsSection
